import { render } from "./SkilupTopComponent.vue?vue&type=template&id=2eb91688&ts=true"
import script from "./SkilupTopComponent.vue?vue&type=script&lang=ts"
export * from "./SkilupTopComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__